import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_KIT = gql(`
  query fetchKit($handle: String!, $isPreview: Boolean = false) {
    kit(handle: $handle, preview: $isPreview) {
      handle
      testimonialsTitle
      testimonialsSubtitle
      testimonials {
        personName
        quote
        occupation
        instagram
        image
      }
      sections {
        __typename
        ... on RawHtmlSection {
          ...RawHtmlSectionFragment
        }
        ...PageBannerSectionFragment
        ...PageHeroSectionFragment
        ...PageTileSectionFragment
      }
      accordion {
        ...AccordionViewFragment
      }
      titleLockupImage {
        ...StyledImageFragment
      }
      promotionalColoredTextSegments{
        ...ColoredTextSegmentFragment
      }
      groupItemsByColor
      defaultColors
      hideProductDetails
      kitToggles {
        id
        name
        kitHandle
      }
    }
  }
`)
